<template>
  <div class="rewind-buttons">
    <button-component
      v-for="value in [...$options.rewindButtons].reverse()"
      :key="`${value}rewind`"
      @btn-click="rewind(-value)"
      :title="$t('VIDEO.rewind_s',{seconds: value})"
    >
      &lt;&lt; {{ value }}
    </button-component>
    <button-component
      @btn-click="togglePause"
      :title="playing ? 'VIDEO.pause' : 'VIDEO.play'"
    >
      {{ $t(playing ? 'VIDEO.pause' : 'VIDEO.play') }}
    </button-component>
    <button-component
      v-for="value in $options.rewindButtons"
      :key="`${value}fastforward`"
      @btn-click="rewind(value)"
      :title="$t('VIDEO.fastForward_s',{seconds: value})"
    >
      {{ value }} &gt;&gt;
    </button-component>
  </div>
</template>

<script>
import ButtonComponent from '../../../components/base-components/buttons/ButtonComponent';
import {PLAYER_ACTIONS} from '@/const';

export default {
  name: 'PlayerRewindButtons',
  components: {ButtonComponent},
  rewindButtons: [1, 5, 10],
  props: {
    playing: {
      type: Boolean,
    },
  },
  methods: {
    rewind(value) {
      this.$emit(PLAYER_ACTIONS.rewind, value);
    },
    togglePause() {
      this.$emit(PLAYER_ACTIONS.play, !this.playing);
    },
  },
};
</script>

<style scoped lang="scss">
.rewind-buttons {
  display: flex;
  gap: .5rem;
  justify-content: center;
  white-space: nowrap;
  flex-wrap: wrap;
}
</style>
